import { Link } from 'react-router-dom';
import type { MediaItem } from '@/types/media';
import { MEDIA_TYPE_LABEL } from '@/types/media';

interface MediaCardProps {
  item: MediaItem;
  showType?: boolean;
}

export default function MediaCard({ item, showType = false }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer focus:outline-none"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-100">
        <img
          src={item.cover}
          alt={`${item.title} 封面`}
          title={`${item.title} - 黄色影视`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-background-950/85 via-background-950/10 to-transparent opacity-80 transition-opacity duration-300 group-hover:opacity-100" />
        <div className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-background-950/70 px-1.5 py-0.5 backdrop-blur">
          <i className="ri-star-fill text-xs text-primary-500"></i>
          <span className="font-label text-xs font-semibold text-foreground-900">{item.rating.toFixed(1)}</span>
        </div>
        {item.badge ? (
          <span className="absolute right-2 top-2 rounded-md bg-accent-500 px-1.5 py-0.5 text-xs font-semibold text-background-50">
            {item.badge}
          </span>
        ) : null}
        <div className="absolute inset-x-0 bottom-0 flex translate-y-3 items-center justify-center pb-3 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-play-fill text-lg"></i>
          </span>
        </div>
      </div>
      <div className="mt-2">
        <h3 className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-500">
          {item.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {showType ? `${MEDIA_TYPE_LABEL[item.type]} · ` : ''}
          {item.genres.slice(0, 2).join(' / ')} · {item.year}
        </p>
      </div>
    </Link>
  );
}